module.exports = __webpack_public_path__ + "img/prosense-guidance-card.cbaa49a5.jpg";